<template>
  <footer class="footer">
    <div class="footer__content _container">
      <div class="ng-footer">
        <div class="ng-footer__top">
          <div class="ng-footer__top-info">
            <p>
              <a href="/">3oaks.com</a> is owned by Green Rock Holding Limited, a company incorporated in the Isle of Man, with company number
              135306C, and registered address situated at Part Ground Floor Suite, 60 Circular Road, Douglas,
              Isle of Man, IM1 1SA. Green Rock Limited, One Rock Limited and Sun Rock LTDA
              are collectively managing <a href="/">3oaks.com</a>.
            </p>
            <p>
              Green Rock Limited, a company incorporated in the Isle of Man, with company number 134595C,
              and registered address situated at Part Ground Floor Suite, 60 Circular Road, Douglas, Isle of Man,
              IM1 1SA.
            </p>
            <p>
              One Rock Limited, a company incorporated in Malta, with company number C103586, and registered
              address situated at No 2, Geraldu Farrugia Street, Zebbug, ZBG 4351, Malta.
            </p>
            <p>
              Sun Rock LTDA, a company incorporated in Brazil, with company number 61.075.584/0001-59,
              and registered address situated at Brazil, City of São Paulo, State of São Paulo, Rua Tabapuã 827,
              Andar 3, Conj. 31, Sala 20, Itaim Bibi, CEP 04533-013.
            </p>
            <div class="ng-footer__images">
              <h4 class="ng-footer__title">Licensed by</h4>
              <div class="images-container">
                <a href="https://www.isleofmangsc.com/gambling/general-supervision/online-gambling-licensee-register/"
                   target="_blank"
                   rel="nofollow noopener noreferrer">
                  <img src="@/assets/img/footer/GSC.png" class="images-logo" />
                </a>
                <a href="https://registers.gamblingcommission.gov.uk/63055"
                  target="_blank"
                  rel="nofollow noopener noreferrer">
                  <img src="@/assets/img/footer/Gambling_Commission.png" class="images-logo" />
                </a>
                <a href="https://onjn.gov.ro/licentiati-clasa-a-ii-a/"
                  target="_blank"
                  rel="nofollow noopener noreferrer">
                  <img src="@/assets/img/footer/ONJN.png" class="images-logo" />
                </a>
                <a href="https://certifications.gamingcommission.gov.gr/publicRecordsOnline/Lists/Kataskevastes/DispForm.aspx?ID=147&Source=https%3A%2F%2Fcertifications%2Egamingcommission%2Egov%2Egr%2FpublicRecordsOnline%2FSitePages%2FKataskevastesOnline%2Easpx&ContentTypeId=0x0100C5BC2D4326D9AB4F89A734B4D3ADC701"
                  target="_blank"
                  rel="nofollow noopener noreferrer">
                  <img src="@/assets/img/footer/eeep.png" class="images-logo" />
                </a>
              </div>
            </div>
            <div class="ng-footer__images">
              <h4 class="ng-footer__title">Certified by</h4>
              <div class="images-container">
                <a href="https://risk-associates.org/use-of-certification-mark/"
                  target="_blank"
                  rel="nofollow noopener noreferrer">
                  <img src="@/assets/img/footer/RA_Certified.png" class="images-logo" />
                </a>
                <a href="https://gamingassociates.com/"
                  target="_blank"
                  rel="nofollow noopener noreferrer">
                  <img src="@/assets/img/footer/ga.png" class="images-logo" />
                </a>
                <a href="https://ecogra.org/"
                  target="_blank"
                  rel="nofollow noopener noreferrer">
                  <img src="@/assets/img/footer/egogra.png" class="images-logo" />
                </a>
                <a href="https://www.riskcherry.com/"
                  target="_blank"
                  rel="nofollow noopener noreferrer">
                  <img src="@/assets/img/footer/RC.png" class="images-logo" />
                </a>
              </div>
            </div>
            <div class="ng-footer__images">
              <h4 class="ng-footer__title">Certified in regulated markets</h4>
              <div class="images-container">
                <img src="@/assets/img/footer/countries/brazil.png" />
                <img src="@/assets/img/footer/countries/bulgaria.png" />
                <img src="@/assets/img/footer/countries/colombia.png" />
                <img src="@/assets/img/footer/countries/georgia.png" />
                <img src="@/assets/img/footer/countries/peru.png" />
                <img src="@/assets/img/footer/countries/italy.png" />
                <img src="@/assets/img/footer/countries/portugal.png" />
                <img src="@/assets/img/footer/countries/netherlands.png" />
                <img src="@/assets/img/footer/countries/greece.png" />
                <img src="@/assets/img/footer/countries/man.png" />
                <img src="@/assets/img/footer/countries/rsa.png" />
                <img src="@/assets/img/footer/countries/romania.png" />
                <img src="@/assets/img/footer/countries/gb.png" />
                <img src="@/assets/img/footer/countries/spain.png" />
              </div>
            </div>
          </div>
          <div class="ng-footer__top-nav">
            <div class="ng-footer__top-site-links" :class="isClientArea ? 'is-client-area': ''">
              <ul class="ng-footer__site-links">
                  <li v-for="menuItem of menuList.slice(
                      0, Math.round(menuList.length/2))"
                  >
                    <span class="split-link">
                      <a class="normal" :href="menuItem.path"
                         :target="menuItem.target"
                      >
                        {{ menuItem.title }}
                      </a>
                      <a class="normal-hovered _hover" :href="menuItem.path"
                         :target="menuItem.target"
                         analytics-role="click"
                         :data-analytics-label="menuItem.title"
                         data-analytics-category="Footer navigation"
                      >
                        {{ menuItem.title }}
                      </a>
                    </span>
                  </li>
                </ul>
                <ul class="ng-footer__site-links">
                  <li v-for="menuItem of menuList.slice(
                      Math.round(menuList.length/2), menuList.length)"
                  >
                    <span class="split-link">
                      <a class="normal" :href="menuItem.path"
                         :target="menuItem.target"
                      >
                        {{ menuItem.title }}
                      </a>
                      <a class="normal-hovered _hover" :href="menuItem.path"
                         :target="menuItem.target"
                      >
                        {{ menuItem.title }}
                      </a>
                    </span>
                  </li>
                </ul>
            </div>
            <div class="ng-footer__network">
              <div class="ng-footer__network-block">
                <h4 class="ng-footer__title">Networks</h4>
                <ul class="ng-footer__social-links">
                  <li>
                    <a href="https://www.facebook.com/3-Oaks-Gaming-108423585065971" target="_blank" rel="nofollow noopener noreferrer">
                      Facebook
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/company/3-oaks-gaming" target="_blank" rel="nofollow noopener noreferrer">
                      LinkedIn
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youtube.com/@3OaksGaming" target="_blank" rel="nofollow noopener noreferrer">
                      Youtube
                    </a>
                  </li>
                </ul>
              </div>
              <div class="ng-footer__network-block">
                <h4 class="ng-footer__title">ABOUT 3 OAKS</h4>
                <p class="ng-footer__text">
                  3 Oaks Gaming is a fast-growing distributor of iGaming content who works alongside established
                  high-value studios to distribute casino content and marketing tools to regulated markets across
                  the globe
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="ng-footer__bottom">
          <div class="ng-footer__bottom-copy">
            <p>© 2025 3 Oaks Gaming. All Rights Reserved</p>
            <p>
              3 Oaks` logos and graphic materials are the company's intellectual property and may
              not be copied, reproduced, distributed or displayed without the written consent of
              Green Rock Limited.
            </p>
          </div>
          <div class="ng-footer__bottom-age-disclaimer">
            <a href="/privacy-notice" class="footer-policy-link">Privacy policy</a>
            <p>3 Oaks Gaming strictly prohibits participation in by persons under the age of 18</p>
            <p>
              <a href="https://www.gambleaware.org/"
                >18+ RESPONSIBLE GAMING</a>
            </p>
            <p>
              <a href="https://www.gambleaware.org/" class="gray-link"
                 target="_blank"
                 rel="nofollow noopener noreferrer">
                gambleaware.org
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
    name: "Footer",
    props: {
        menuList: Array
    },
  data() {
      return {
        isClientArea: false
      }
  },
  mounted() {
      this.isClientArea = window.location.href.includes('client-area') ? 'Client area' : 'Public area';
  }
}
</script>
